import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* CRANE — side view orizuru with neck up-left, tail-fin up-right, wings spread low */
export const Crane = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="crane-l" light="#ffe6ec" dark="#ffc7d3"/>
      <PaperGrad id="crane-d" light="#ffc7d3" dark="#f59aac"/>
    </defs>
    {/* back wing (right) */}
    <polygon points="68,64 116,96 70,100" fill="url(#crane-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="68" y1="64" x2="100" y2="92" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* tail fin */}
    <polygon points="68,64 96,8 84,68" fill="url(#crane-l)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="68" y1="64" x2="92" y2="20" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* body diamond */}
    <polygon points="56,40 80,68 56,108 36,68" fill="url(#crane-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    <polygon points="56,40 36,68 56,68" fill="url(#crane-d)" opacity="0.7" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2"/>
    <line x1="56" y1="40" x2="56" y2="108" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* front wing (left, on top) */}
    <polygon points="40,64 4,86 52,102" fill="url(#crane-l)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="40" y1="64" x2="28" y2="92" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* neck */}
    <polygon points="42,54 22,22 32,18 50,52" fill="url(#crane-l)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="32" y1="20" x2="48" y2="52" stroke={STROKE} strokeWidth="0.6" strokeDasharray="2 2"/>
    {/* head with beak down-left */}
    <polygon points="22,22 4,32 32,18" fill="url(#crane-l)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="22" y1="22" x2="14" y2="30" stroke={STROKE} strokeWidth="0.6" strokeDasharray="2 2"/>
    <BeadyEye cx={20} cy={25} r={1.8}/>
  </svg>
)
